import {
  SaleProductGroupCreateBody,
  SaleProductGroupListResponse,
  SaleProductGroupItem,
  SaleProductGroupDetailResponse,
} from "utils/api/client/types"

export class SaleProductGroup {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: SaleProductGroupCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<{ data: SaleProductGroupItem }> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-product-group`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: SaleProductGroupCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleProductGroupItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-product-group/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleProductGroupListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-product-group`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleProductGroupDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-product-group/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string | number,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sale-reps-product-group/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
